export default __webpack_public_path__ + "acb26918194c58ce2123658bdb23aceb.svg";